import React from "react";

const GameTypeSelector = props => {

  return (
    <table className="game-type-selector" valign="top" border="0">
      <thead><tr><th>Game Type</th></tr></thead>
      <tbody>
        <tr>
          <td> <input 
                 type="radio" 
                 value="notes" 
                 checked={props.gameType === 'notes'}
                 onChange={() => props.callbacks.gameTypeSetter('notes')} /> Notes </td>
        </tr>
        <tr>
          <td> <input
                 type="radio"
                 value="frets"
                 checked={props.gameType === 'frets'}
                 onChange={() => props.callbacks.gameTypeSetter('frets')} /> Frets</td>
        </tr>
      </tbody>
    </table>
  );

};

export default GameTypeSelector;






